import {activityPlaces} from '@mep/pae-commons';

const {ACTIVITY_PLACE_STATUS, ACTIVITY_PLACE_LINK_TYPES, ACTIVITY_PLACE_TYPES} = activityPlaces;

export const ACTIVITY_PLACE_STATUS_APPEARANCE = {
  [ACTIVITY_PLACE_STATUS.PENDING]: {color: 'blue'},
  [ACTIVITY_PLACE_STATUS.IN_REVIEW]: {color: 'orange'},
  [ACTIVITY_PLACE_STATUS.ACCEPTED]: {color: 'green'},
  [ACTIVITY_PLACE_STATUS.REJECTED]: {color: 'red'},
};

export const ACTIVITY_PLACE_TYPES_APPEARANCE = {
  [ACTIVITY_PLACE_TYPES.AMBULATORY]: {color: 'orange'},
  [ACTIVITY_PLACE_TYPES.SEA]: {color: 'blue'},
  [ACTIVITY_PLACE_TYPES.TRANSPORT_PUBLIC_VIA]: {color: 'green'},
  [ACTIVITY_PLACE_TYPES.PUBLIC_VIA]: {color: 'green'},
  [ACTIVITY_PLACE_TYPES.OWN_ADDRESS]: {color: 'orange'},
  [ACTIVITY_PLACE_TYPES.CUSTOMER_ADDRESS]: {color: 'orange'},
  [ACTIVITY_PLACE_TYPES.LEASE_SPACE_AREA]: {color: 'gray'},
  [ACTIVITY_PLACE_TYPES.LEASE_ENABLED_AREA]: {color: 'gray'},
  [ACTIVITY_PLACE_TYPES.OTHER]: {color: 'black'},
};

export const ACTIVITY_PLACE_LINK_TYPE_APPEARANCE = {
  [ACTIVITY_PLACE_LINK_TYPES.STATE_ARRENDATE]: {color: 'purple'},
  [ACTIVITY_PLACE_LINK_TYPES.FGNE_ARRENDATE]: {color: 'green'},
  [ACTIVITY_PLACE_LINK_TYPES.SELF_OWNER]: {color: 'orange'},
  [ACTIVITY_PLACE_LINK_TYPES.FROM_FAMILY]: {color: 'blue'},
  [ACTIVITY_PLACE_LINK_TYPES.OTHER]: {color: 'gray'},
};
